import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import { Avatar, PopoverModal } from 'components/UI'
import LogOut from './LogOut'
import MenuItemOrigin from '@mui/material/MenuItem'
// hooks
import { useCurrentUser } from 'hooks'
// themes
import { colors } from 'themes'
// utils
import { safeGetOr } from 'utils/fp'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  }
}

// styled
const UserDetailsWrapper = styled.div`
  padding: 16px;
  height: 72px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  cursor: pointer;
`

const UserName = styled.div`
  font-size: 16px;
  color: ${colors.white};
  font-weight: bold;

  margin-left: 16px;
`

const MenuItem = styled(MenuItemOrigin)`
  && {
    cursor: pointer;
    min-height: 40px;
    padding: 0 16px;
  }
`

// types
interface Props {
  isExpanded: boolean
}

const UserBlock: React.FC<Props> = ({ isExpanded }) => {
  const user = useCurrentUser()
  const router = useRouter()

  const handleSecurityClick = () => {
    router.push('/account/security')
  }

  return (
    <PopoverModal
      {...MODAL_PROPS}
      trigger={
        <UserDetailsWrapper data-testid='user-menu-trigger'>
          <Avatar user={user} />
          {isExpanded && (
            <UserName>
              {safeGetOr<any, any, any>('', 'firstName')(user)}
              <br />
              {safeGetOr<any, any, any>('', 'lastName')(user)}
            </UserName>
          )}
        </UserDetailsWrapper>
      }>
      {() => (
        <>
          <MenuItem onClick={handleSecurityClick}>Security</MenuItem>
          <LogOut />
        </>
      )}
    </PopoverModal>
  )
}

export default UserBlock
